<template>
  <el-card class="box-card">
    <div slot="header" class="flex justify-between">
      <span>拼团订单</span>
      <el-button
        type="primary"
        size="small"
        class="float-right"
        @click="_toGroupOrderPage"
      >管理</el-button>
    </div>
    <div class="table-container">
      <el-table
        :data="shopOrderGroupInfo.productGroupOrders"
        style="width: 100%"
        height="450"
        border
      >
        <el-table-column label="商品名称" align="center">
          <template slot-scope="scope">
            【{{scope.row.userCount}}人团】{{scope.row.prodName}}
          </template>
        </el-table-column>
        <el-table-column label="团长/购买者" align="center">
          <template slot-scope="scope">
            {{scope.row.groupBuyerName}}<br>{{scope.row.buyerName}}
          </template>
        </el-table-column>
        <el-table-column label="数量/金额" align="center">
          <template slot-scope="scope">
            {{scope.row.buyerCount}}/{{scope.row.groupPrice}}
          </template>
        </el-table-column>
        <el-table-column label="拼团人数" align="center">
          <template slot-scope="scope">
            {{scope.row.groupCount}}/{{scope.row.userCount}}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
        <el-table-column label="有效期" align="center">
          <template slot-scope="scope">
            {{scope.row.openTime}}<br>~{{scope.row.endTime}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="拼团时间" align="center"></el-table-column>
      </el-table>
      <el-pagination
        class="pagination-container"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import { getProductGroupOrderList } from '@/api/order/shopOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopOrderGroup',
  data() {
    return {
      shopOrderGroupInfo: {
        productGroupOrders: [],
        link: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 7,
        total: 0
      }
    }
  },
  created() {
    this._loadShopOrderGroupData(this.pagination.currentPage, this.pagination.pageSize)
  },
  methods: {
    _toGroupOrderPage() {
      window.open('/#/pages/group/productGroupOrderManage?tab=拼团订单')
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this._loadShopOrderGroupData(val, this.pagination.pageSize)
    },
    _loadShopOrderGroupData(page, row) {
      const params = {
        shopId: getShopId(),
        page,
        row
      }

      getProductGroupOrderList(params).then(res => {
        this.shopOrderGroupInfo.productGroupOrders = res.data
        this.pagination.total = res.records
      }).catch(() => {
        console.log('请求失败处理')
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.float-right {
  float: right;
}
.table-container {
  height: 450px;
  overflow-y: auto;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>